import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PartnersSection.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

function PartnersSection() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/partners`);
        setPartners(response.data);
      } catch (err) {
        console.error("Error fetching partners:", err.message);
      }
    };
    fetchPartners();
  }, []);

  return (
<section className="partners-section">
   <h2 className="how-title">Naši partneri</h2>
  <div className="partners-logos">
    {partners.map((p) => (
      <img key={p.id} src={p.image} alt={p.alt} />
    ))}
  </div>
</section>

  );
}

export default PartnersSection;
